import { Locale } from '@/graphql/creator-platform/generated'
import { storeConfig } from '@/locale'

export enum Font {
  AmaticSCBold = 'Amatic-SC-Bold',
  AntonRegular = 'Anton-Regular',
  AryaDouble = 'Arya-Double',
  BebasNeueRegular = 'BebasNeue-Regular',
  BorelRegular = 'Borel-Regular',
  BungeeRegular = 'Bungee-Regular',
  ClosenessBold = 'Closeness-Bold',
  CoFoSansPixelRegular = 'CoFo-Sans-Pixel-Regular',
  CoinyRegular = 'Coiny-Regular',
  ComoBold = 'Como-Bold',
  Cortado = 'Cortado',
  CwTeXMingZhonly = '明體',
  GuyotHeadlineBlack = 'Guyot-Headline-Black',
  HoltwoodOneSC = 'HoltwoodOneSC',
  JaroRegular = 'Jaro-Regular',
  LibreBaskervilleBold = 'LibreBaskerville-Bold',
  MerriweatherBold = 'Merriweather-Bold',
  MerriweatherBoldItalic = 'Merriweather-BoldItalic',
  NotoSansCJKtcBlack = 'NotoSansCJKtc-Black', // '黑體'
  NotoSansCJKtcBlackInZh = '黑體',
  NotoSansJPBold = 'NotoSans JP 日本語対応フォント',
  NotoSansKRBlack = 'NotoSans KR 한국어 지원 폰트',
  NotoSansThaiBold = 'NotoSans-Thai',
  OswaldSemiBold = 'Oswald-SemiBold',
  PermanentMarkerRegular = 'PermanentMarker-Regular',
  PressStart2PRegular = 'PressStart2P-Regular',
  QuanticoBold = 'Quantico-Bold',
  QuanticoBoldItalic = 'Quantico-BoldItalic',
  RobotoBold = 'Roboto-Bold',
  RobotoBoldItalic = 'Roboto-BoldItalic',
  SarinaRegular = 'Sarina-Regular',
}

/**
 * Noto Sans 系列使用 Google Fonts unicode-range 子集載入，解決 ~15MB 完整字體的效能問題。
 * Google Fonts family name → Font enum(s) 的對應。
 */
export const GOOGLE_FONTS_NAME_MAP: Record<string, Font[]> = {
  'Noto Sans TC': [Font.NotoSansCJKtcBlack, Font.NotoSansCJKtcBlackInZh],
  'Noto Sans JP': [Font.NotoSansJPBold],
  'Noto Sans KR': [Font.NotoSansKRBlack],
  'Noto Sans Thai': [Font.NotoSansThaiBold],
}

/**
 * 所有其他字體從 CDN 載入完整字體檔（原始做法）。
 */
export const fonts: Record<string, string> = {
  [Font.RobotoBold]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Roboto-Bold.ttf?6715089704466941401',
  [Font.RobotoBoldItalic]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Roboto-BoldItalic.ttf?6715089704466941401',
  [Font.AntonRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Anton-Regular.ttf?6715089704466941401',
  [Font.OswaldSemiBold]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Oswald-SemiBold.ttf?6715089704466941401',
  [Font.BungeeRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Bungee-Regular.ttf?6715089704466941401',
  [Font.CoinyRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Coiny-Regular.ttf?6715089704466941401',
  [Font.QuanticoBold]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Quantico-Bold.ttf?6715089704466941401',
  [Font.QuanticoBoldItalic]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Quantico-BoldItalic.ttf?6715089704466941401',
  [Font.MerriweatherBold]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Merriweather-Bold.ttf?6715089704466941401',
  [Font.MerriweatherBoldItalic]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Merriweather-BoldItalic.ttf?6715089704466941401',
  [Font.LibreBaskervilleBold]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/LibreBaskerville-Bold.ttf?6715089704466941401',
  [Font.HoltwoodOneSC]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/HoltwoodOneSC.ttf?6715089704466941401',
  [Font.SarinaRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/Sarina-Regular.ttf?6715089704466941401',
  [Font.PermanentMarkerRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/PermanentMarker-Regular.ttf?6715089704466941401',
  [Font.PressStart2PRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/PressStart2P-Regular.ttf?6715089704466941401',
  [Font.BebasNeueRegular]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/BebasNeue-Regular.ttf?v=1627960399',
  [Font.CwTeXMingZhonly]:
    'https://cdn.shopify.com/s/files/1/0274/8717/files/cwTeXMing-zhonly.ttf?4706141921037546365',
  [Font.AmaticSCBold]: 'https://assets.amuse.com.tw/fonts/Amatic-SC-Bold.otf',
  [Font.BorelRegular]: 'https://assets.amuse.com.tw/fonts/Borel-Regular.otf',
  [Font.ClosenessBold]: 'https://assets.amuse.com.tw/fonts/Closeness-Bold.ttf',
  [Font.CoFoSansPixelRegular]: 'https://assets.amuse.com.tw/fonts/CoFo-Sans-Pixel-Regular.otf',
  [Font.ComoBold]: 'https://assets.amuse.com.tw/fonts/Como-Bold.otf',
  [Font.AryaDouble]: 'https://assets.amuse.com.tw/fonts/Arya-Double.otf',
  [Font.Cortado]: 'https://assets.amuse.com.tw/fonts/Cortado.otf',
  [Font.GuyotHeadlineBlack]: 'https://assets.amuse.com.tw/fonts/Guyot-Headline-Black.otf',
  [Font.JaroRegular]: 'https://assets.amuse.com.tw/fonts/Jaro-Regular.otf',
}

export function isDesignFont(fontFamily: string): fontFamily is Font {
  const fonts: string[] = Object.values(Font)
  return fonts.includes(fontFamily)
}

/**
 * 在字型選單中隱藏的字體。
 * 這些字體供 canvas fallback 使用，但不應展示給使用者自行選擇。
 */
export const hiddenFonts: ReadonlySet<Font> = new Set([Font.NotoSansKRBlack])

/**
 * 各 locale 的黑體 fallback chain：本語言字體排第一，其餘三個 NotoSans 作後備。
 * 讓使用者不論在哪個 locale，預設就能輸入中、日、韓、泰文。
 * 未列出的 locale 使用預設順序（TC 優先）。
 */
const FALLBACK_FONTS_BY_LOCALE: Partial<Record<Locale, readonly Font[]>> = {
  [Locale.Kr]: [
    Font.NotoSansKRBlack,
    Font.NotoSansCJKtcBlack,
    Font.NotoSansJPBold,
    Font.NotoSansThaiBold,
  ],
  [Locale.Th]: [
    Font.NotoSansThaiBold,
    Font.NotoSansCJKtcBlack,
    Font.NotoSansJPBold,
    Font.NotoSansKRBlack,
  ],
}

export const fallbackFonts: readonly Font[] = FALLBACK_FONTS_BY_LOCALE[storeConfig.locale] ?? [
  Font.NotoSansCJKtcBlack,
  Font.NotoSansJPBold,
  Font.NotoSansKRBlack,
  Font.NotoSansThaiBold,
]
